const bespokeServerAppMockups3Html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Bespoke Server App — Style Explorations III</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Nunito:wght@400;600;700;800;900&display=swap');

*{margin:0;padding:0;box-sizing:border-box}

body{
  background:#111;
  color:#fff;
  font-family:system-ui,-apple-system,sans-serif;
  padding:40px 20px;
}

h1{text-align:center;font-size:28px;font-weight:700;margin-bottom:8px;letter-spacing:-0.5px}
.subtitle{text-align:center;font-size:14px;color:#888;margin-bottom:40px}

.grid-wrapper{
  display:grid;
  grid-template-columns:80px repeat(3,375px);
  grid-template-rows:40px repeat(3,812px);
  gap:24px;
  justify-content:center;
  align-items:start;
}

.col-header{text-align:center;font-size:16px;font-weight:700;letter-spacing:1px;text-transform:uppercase;display:flex;align-items:end;justify-content:center;padding-bottom:8px}
.col-header.fitbit{color:#00B4D8}
.col-header.strava{color:#FC4C02}
.col-header.snackpass{color:#FF2D78}

.row-label{writing-mode:vertical-lr;transform:rotate(180deg);font-size:13px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#666;display:flex;align-items:center;justify-content:center}

.phone{width:375px;height:812px;border-radius:40px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.5),0 0 0 3px #333;position:relative}

.corner{grid-column:1;grid-row:1}

.footer{text-align:center;font-size:12px;color:#555;margin-top:40px;padding-bottom:40px}

/* ========== FITBIT COMMON ========== */
.fit{
  font-family:'Inter',system-ui,sans-serif;
  background:#FFFFFF;
  color:#1a1a1a;
  height:100%;
  display:flex;
  flex-direction:column;
}
.fit .sb{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#999;font-weight:500}
.fit .nb{display:flex;justify-content:space-around;padding:12px 0 28px;border-top:1px solid #eee;margin-top:auto;background:#fff}
.fit .nb span{font-size:10px;color:#999;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px}
.fit .nb span.a{color:#00B4D8}
.fit .page-title{padding:16px 24px 0;font-size:22px;font-weight:700}
.fit .page-sub{padding:4px 24px 16px;font-size:13px;color:#999;font-weight:500}

.fit .card{background:#F8FAFB;border-radius:16px;margin:8px 20px;padding:16px 20px}
.fit .card .ct{font-size:11px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px}
.fit .card .cv{font-size:24px;font-weight:700;color:#1a1a1a}
.fit .card .cv span{color:#00B4D8}
.fit .card .cs{font-size:12px;color:#999;margin-top:4px}

.fit .list-item{display:flex;align-items:center;gap:12px;padding:13px 24px;border-bottom:1px solid #f0f0f0}
.fit .list-item .li-icon{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0}
.fit .list-item .li-icon.teal{background:#E8F8FB;color:#00B4D8}
.fit .list-item .li-icon.gray{background:#f5f5f5;color:#ccc}
.fit .list-item .li-text{flex:1}
.fit .list-item .li-text .t1{font-size:14px;font-weight:600;color:#1a1a1a}
.fit .list-item .li-text .t2{font-size:11px;color:#999;margin-top:1px}
.fit .list-item .li-right{font-size:13px;font-weight:600;color:#999;text-align:right}
.fit .list-item .li-right.teal{color:#00B4D8}

.fit .divider{height:1px;background:#f0f0f0;margin:0 24px}

.fit .stat-row{display:flex;gap:8px;padding:8px 20px}
.fit .stat-box{flex:1;background:#F8FAFB;border-radius:12px;padding:12px;text-align:center}
.fit .stat-box .sv{font-size:20px;font-weight:700;color:#00B4D8}
.fit .stat-box .sl{font-size:10px;color:#999;margin-top:2px}

.fit .progress-ring-sm{width:48px;height:48px;flex-shrink:0}
.fit .ring-bg-sm{fill:none;stroke:#E8F8FB;stroke-width:5}
.fit .ring-fg-sm{fill:none;stroke:#00B4D8;stroke-width:5;stroke-linecap:round;transform:rotate(-90deg);transform-origin:center}

.fit .tag{display:inline-block;padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600}
.fit .tag.teal{background:#E8F8FB;color:#00B4D8}
.fit .tag.green{background:#E8F8E8;color:#2DA32D}
.fit .tag.amber{background:#FFF8E8;color:#D49B00}

/* ========== STRAVA COMMON ========== */
.stv{
  font-family:system-ui,-apple-system,sans-serif;
  background:#1a1a2e;
  color:#fff;
  height:100%;
  display:flex;
  flex-direction:column;
}
.stv .sb{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#555;font-weight:500}
.stv .nb{display:flex;justify-content:space-around;padding:12px 0 28px;border-top:1px solid #2a2a4e;margin-top:auto;background:#1a1a2e}
.stv .nb span{font-size:10px;color:#555;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px}
.stv .nb span.a{color:#FC4C02}

.stv .hero{margin:8px 16px;border-radius:16px;padding:24px;position:relative;overflow:hidden}
.stv .hero.orange{background:linear-gradient(135deg,#FC4C02 0%,#e04400 50%,#c03800 100%)}
.stv .hero.dark{background:linear-gradient(135deg,#2a2a4e 0%,#1e1e3a 100%);border:1px solid #333366}
.stv .hero .tag{font-size:10px;text-transform:uppercase;letter-spacing:2px;color:rgba(255,255,255,0.6);margin-bottom:6px}
.stv .hero h2{font-size:22px;font-weight:800;line-height:1.2}
.stv .hero .sub{font-size:13px;color:rgba(255,255,255,0.7);margin-top:6px}

.stv .section-label{padding:16px 20px 8px;font-size:11px;font-weight:600;color:#666;text-transform:uppercase;letter-spacing:1.5px}

.stv .row-item{display:flex;align-items:center;gap:12px;padding:13px 20px;border-bottom:1px solid #2a2a4e}
.stv .row-item .ri-icon{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0}
.stv .row-item .ri-icon.orange{background:rgba(252,76,2,0.15);color:#FC4C02}
.stv .row-item .ri-icon.dim{background:#2a2a4e;color:#555}
.stv .row-item .ri-text{flex:1}
.stv .row-item .ri-text .t1{font-size:14px;font-weight:600}
.stv .row-item .ri-text .t2{font-size:11px;color:#666;margin-top:1px}
.stv .row-item .ri-right{font-size:13px;font-weight:700;color:#FC4C02}

.stv .stat-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:8px 16px}
.stv .stat-card{background:#2a2a4e;border-radius:12px;padding:14px;text-align:center}
.stv .stat-card .sv{font-size:22px;font-weight:800}
.stv .stat-card .sv.orange{color:#FC4C02}
.stv .stat-card .sl{font-size:10px;color:#666;margin-top:2px;text-transform:uppercase}

.stv .seg-bar{height:8px;background:#2a2a4e;border-radius:4px;overflow:hidden;margin:0 20px}
.stv .seg-bar .fill{height:100%;background:linear-gradient(90deg,#FC4C02,#FF6B35);border-radius:4px}
.stv .seg-label{display:flex;justify-content:space-between;padding:6px 20px 0;font-size:10px;color:#555}

.stv .btn{margin:8px 16px;padding:12px;border-radius:12px;text-align:center;font-size:14px;font-weight:700;cursor:pointer;border:none}
.stv .btn.outline{background:transparent;border:2px solid #FC4C02;color:#FC4C02}
.stv .btn.solid{background:#FC4C02;color:#fff}

.stv .pill{display:inline-block;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:700}
.stv .pill.orange{background:rgba(252,76,2,0.15);color:#FC4C02}
.stv .pill.green{background:rgba(34,197,94,0.15);color:#22C55E}

/* ========== SNACKPASS COMMON ========== */
.snk{
  font-family:'Nunito',system-ui,sans-serif;
  background:#FFFFFF;
  color:#1a1a1a;
  height:100%;
  display:flex;
  flex-direction:column;
}
.snk .sb{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#999;font-weight:700}
.snk .nb{display:flex;justify-content:space-around;padding:12px 0 28px;border-top:1px solid #f0f0f0;margin-top:auto;background:#fff}
.snk .nb span{font-size:10px;color:#bbb;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;font-weight:800}
.snk .nb span.a{color:#FF2D78}

.snk .gradient-card{margin:8px 16px;border-radius:24px;padding:24px;color:#fff;position:relative;overflow:hidden}
.snk .gradient-card.pink{background:linear-gradient(135deg,#FF2D78 0%,#FF6B9D 50%,#FFD600 100%)}
.snk .gradient-card.yellow{background:linear-gradient(135deg,#FFD600 0%,#FFC107 100%);color:#1a1a1a}
.snk .gradient-card.soft{background:linear-gradient(135deg,#FFF5F8 0%,#FFF9E6 100%);color:#1a1a1a;border:2px solid #FFE0EC}
.snk .gradient-card .emoji-lg{font-size:44px;display:block;margin-bottom:8px}
.snk .gradient-card h2{font-size:20px;font-weight:900}
.snk .gradient-card .sub{font-size:13px;font-weight:600;margin-top:4px;opacity:0.85}

.snk .bubble{display:inline-flex;align-items:center;gap:4px;padding:6px 16px;border-radius:50px;font-size:13px;font-weight:700}
.snk .bubble.pink{background:#FFF0F5;color:#FF2D78}
.snk .bubble.yellow{background:#FFFCE6;color:#D49B00}
.snk .bubble.green{background:#E8FFE8;color:#22C55E}
.snk .bubble-wrap{display:flex;gap:8px;padding:8px 20px;flex-wrap:wrap;justify-content:center}

.snk .feed-item{margin:6px 16px;background:#FAFAFA;border-radius:20px;padding:14px 16px;display:flex;align-items:center;gap:12px}
.snk .feed-item .emoji{font-size:28px;flex-shrink:0}
.snk .feed-item .text{flex:1}
.snk .feed-item .text .t1{font-size:13px;font-weight:700;color:#1a1a1a}
.snk .feed-item .text .t2{font-size:11px;color:#999;font-weight:600;margin-top:2px}
.snk .feed-item .action{padding:6px 14px;border-radius:50px;font-size:11px;font-weight:800;border:none;cursor:pointer;font-family:'Nunito',sans-serif}
.snk .feed-item .action.pink{background:#FF2D78;color:#fff}
.snk .feed-item .action.outline{background:#fff;border:2px solid #FF2D78;color:#FF2D78}

.snk .section-title{padding:14px 20px 6px;font-size:16px;font-weight:900;color:#1a1a1a}

.snk .quick-stats{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;padding:8px 16px}
.snk .qs{background:#FFF5F8;border-radius:16px;padding:12px 8px;text-align:center}
.snk .qs .v{font-size:20px;font-weight:900;color:#FF2D78}
.snk .qs .l{font-size:9px;color:#999;font-weight:700;margin-top:2px}

/* ========== FITBIT: PRE-SHIFT BRIEFING ========== */
.fit .briefing-header{
  background:linear-gradient(135deg,#E8F8FB 0%,#fff 100%);
  margin:0 16px;
  border-radius:16px;
  padding:20px;
  border:1px solid #d0eef4;
}
.fit .briefing-header .emoji{font-size:32px;margin-bottom:8px;display:block}
.fit .briefing-header .title{font-size:18px;font-weight:700;color:#1a1a1a}
.fit .briefing-header .subtitle{font-size:13px;color:#999;margin-top:4px}

.fit .matchup{display:flex;align-items:center;gap:12px;padding:12px 20px}
.fit .matchup .vs{font-size:12px;font-weight:700;color:#ccc}
.fit .matchup .player{display:flex;flex-direction:column;align-items:center;gap:4px;flex:1}
.fit .matchup .player .avatar{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:700;color:#fff}
.fit .matchup .player .name{font-size:11px;font-weight:600;color:#1a1a1a}
.fit .matchup .player .stat{font-size:10px;color:#999}
.fit .matchup .player.you .avatar{box-shadow:0 0 0 3px #00B4D8}

/* ========== STRAVA: PRE-SHIFT ========== */
.stv .warmup-card{margin:8px 16px;background:#2a2a4e;border-radius:16px;padding:20px;border:1px solid #333366}
.stv .warmup-card .header{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}
.stv .warmup-card .header h3{font-size:16px;font-weight:800}
.stv .warmup-card .header .badge{padding:4px 10px;background:rgba(252,76,2,0.15);border-radius:8px;font-size:11px;font-weight:700;color:#FC4C02}
.stv .warmup-card .stat-line{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #333366;font-size:13px}
.stv .warmup-card .stat-line .label{color:#888}
.stv .warmup-card .stat-line .value{font-weight:700}

.stv .rival-row{display:flex;align-items:center;gap:16px;padding:12px 20px}
.stv .rival-row .avatar{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:800}
.stv .rival-row .avatar.orange{background:#FC4C02;color:#fff}
.stv .rival-row .avatar.dim{background:#333366;color:#888}
.stv .rival-row .avatar.you{box-shadow:0 0 0 3px #FC4C02}
.stv .rival-row .info{flex:1}
.stv .rival-row .info .name{font-size:14px;font-weight:700}
.stv .rival-row .info .sub{font-size:11px;color:#666}
.stv .rival-row .threat{font-size:11px;font-weight:700;padding:4px 10px;border-radius:8px}
.stv .rival-row .threat.high{background:rgba(252,76,2,0.15);color:#FC4C02}
.stv .rival-row .threat.low{background:rgba(34,197,94,0.15);color:#22C55E}

/* ========== SNACKPASS: PRE-SHIFT ========== */
.snk .quest-card{margin:8px 16px;background:linear-gradient(135deg,#FF2D78,#FF6B9D);border-radius:24px;padding:20px;color:#fff}
.snk .quest-card .top-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}
.snk .quest-card .top-row .emoji{font-size:32px}
.snk .quest-card .top-row .xp{padding:4px 12px;background:rgba(255,255,255,0.25);border-radius:50px;font-size:12px;font-weight:800}
.snk .quest-card h3{font-size:18px;font-weight:900;margin-bottom:4px}
.snk .quest-card .desc{font-size:12px;font-weight:600;opacity:0.85}

.snk .opponent-card{margin:6px 16px;background:#FFF5F8;border:2px solid #FFE0EC;border-radius:20px;padding:14px 16px;display:flex;align-items:center;gap:12px}
.snk .opponent-card .avatar{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0}
.snk .opponent-card .avatar.pink{background:linear-gradient(135deg,#FF2D78,#FF6B9D)}
.snk .opponent-card .avatar.yellow{background:linear-gradient(135deg,#FFD600,#FFC107)}
.snk .opponent-card .avatar.purple{background:linear-gradient(135deg,#8B5CF6,#A78BFA)}
.snk .opponent-card .info{flex:1}
.snk .opponent-card .info .name{font-size:14px;font-weight:800}
.snk .opponent-card .info .sub{font-size:11px;color:#999;font-weight:600}
.snk .opponent-card .tag{padding:4px 10px;border-radius:50px;font-size:10px;font-weight:800}
.snk .opponent-card .tag.you{background:#FF2D78;color:#fff}
.snk .opponent-card .tag.rival{background:#FFE0EC;color:#FF2D78}

/* ========== MOMENTUM STYLES ========== */
.fit .momentum-ring{display:flex;justify-content:center;padding:20px 0 8px}
.fit .momentum-ring svg{width:160px;height:160px}
.fit .ring-bg-lg{fill:none;stroke:#E8F8FB;stroke-width:10}
.fit .ring-fg-lg{fill:none;stroke:#00B4D8;stroke-width:10;stroke-linecap:round;transform:rotate(-90deg);transform-origin:center}
.fit .ring-text-lg{font-family:'Inter',sans-serif;fill:#1a1a1a;font-weight:800;font-size:32px;text-anchor:middle}
.fit .ring-sub-lg{font-family:'Inter',sans-serif;fill:#999;font-size:11px;text-anchor:middle}

.fit .timeline{padding:0 20px;margin-top:8px}
.fit .timeline .tl-item{display:flex;gap:12px;padding:0 0 16px}
.fit .timeline .tl-dot-col{display:flex;flex-direction:column;align-items:center;width:20px}
.fit .timeline .tl-dot{width:12px;height:12px;border-radius:50%;flex-shrink:0}
.fit .timeline .tl-dot.teal{background:#00B4D8}
.fit .timeline .tl-dot.gray{background:#E5E5E5}
.fit .timeline .tl-line{width:2px;flex:1;background:#E5E5E5;margin-top:4px}
.fit .timeline .tl-line.teal{background:#00B4D8}
.fit .timeline .tl-content .t1{font-size:13px;font-weight:600;color:#1a1a1a}
.fit .timeline .tl-content .t2{font-size:11px;color:#999}

.stv .energy-meter{margin:8px 16px;background:#2a2a4e;border-radius:16px;padding:20px;border:1px solid #333366;text-align:center}
.stv .energy-meter .label{font-size:11px;text-transform:uppercase;letter-spacing:2px;color:#666;margin-bottom:12px}
.stv .energy-meter .bars{display:flex;gap:4px;justify-content:center;height:80px;align-items:flex-end}
.stv .energy-meter .bar{width:16px;border-radius:4px 4px 0 0}
.stv .energy-meter .bar.on{background:linear-gradient(180deg,#FC4C02,#FF6B35)}
.stv .energy-meter .bar.off{background:#333366}
.stv .energy-meter .level{font-size:24px;font-weight:900;color:#FC4C02;margin-top:12px}
.stv .energy-meter .sub{font-size:12px;color:#888;margin-top:4px}

.stv .streak-banner{margin:8px 16px;background:linear-gradient(90deg,#FC4C02,#FF6B35);border-radius:12px;padding:14px 20px;display:flex;align-items:center;gap:12px}
.stv .streak-banner .icon{font-size:28px}
.stv .streak-banner .text{flex:1}
.stv .streak-banner .text .t1{font-size:15px;font-weight:800}
.stv .streak-banner .text .t2{font-size:11px;opacity:0.8}

.snk .momentum-emoji-track{display:flex;justify-content:center;gap:4px;padding:16px 20px 8px}
.snk .momentum-emoji-track .step{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:20px}
.snk .momentum-emoji-track .step.done{background:linear-gradient(135deg,#FF2D78,#FF6B9D);box-shadow:0 3px 10px rgba(255,45,120,0.25)}
.snk .momentum-emoji-track .step.next{background:#FFD600;animation:snk-bounce 1.5s infinite}
.snk .momentum-emoji-track .step.pending{background:#f0f0f0}
@keyframes snk-bounce{0%,100%{transform:scale(1)}50%{transform:scale(1.12)}}

.snk .hype-card{margin:8px 16px;border-radius:20px;padding:16px 20px;text-align:center}
.snk .hype-card.fire{background:linear-gradient(135deg,#FF2D78,#FF6B9D);color:#fff}
.snk .hype-card .big{font-size:36px;font-weight:900}
.snk .hype-card .label{font-size:13px;font-weight:700;margin-top:4px}

/* ========== COACHING STYLES ========== */
.fit .coach-card{margin:8px 20px;padding:16px;border-radius:16px;border:1px solid #d0eef4;background:linear-gradient(135deg,#F8FDFB 0%,#F0FAFC 100%)}
.fit .coach-card .coach-header{display:flex;align-items:center;gap:10px;margin-bottom:10px}
.fit .coach-card .coach-header .ai-badge{width:28px;height:28px;border-radius:50%;background:#00B4D8;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:800;color:#fff}
.fit .coach-card .coach-header .label{font-size:12px;font-weight:600;color:#00B4D8}
.fit .coach-card .coach-body{font-size:13px;color:#444;line-height:1.6}
.fit .coach-card .coach-body strong{color:#1a1a1a}
.fit .coach-card .coach-script{margin-top:10px;padding:10px 14px;background:#E8F8FB;border-radius:10px;font-size:12px;color:#0090A8;font-style:italic;line-height:1.5;border-left:3px solid #00B4D8}
.fit .coach-card .coach-footer{display:flex;gap:8px;margin-top:10px}
.fit .coach-card .coach-btn{padding:6px 14px;border-radius:8px;font-size:11px;font-weight:600;border:none;cursor:pointer;font-family:'Inter',sans-serif}
.fit .coach-card .coach-btn.primary{background:#00B4D8;color:#fff}
.fit .coach-card .coach-btn.secondary{background:#E8F8FB;color:#00B4D8}

.stv .coach-feed-item{margin:6px 16px;background:#2a2a4e;border-radius:12px;padding:16px;border:1px solid #333366}
.stv .coach-feed-item .top{display:flex;align-items:center;gap:10px;margin-bottom:10px}
.stv .coach-feed-item .top .ai{width:28px;height:28px;border-radius:50%;background:#FC4C02;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800}
.stv .coach-feed-item .top .label{font-size:11px;font-weight:600;color:#FC4C02}
.stv .coach-feed-item .top .time{font-size:10px;color:#555;margin-left:auto}
.stv .coach-feed-item .body{font-size:13px;color:#ccc;line-height:1.5}
.stv .coach-feed-item .body strong{color:#fff}
.stv .coach-feed-item .script{margin-top:10px;padding:10px 14px;background:#1e1e3a;border-radius:10px;font-size:12px;color:#FC4C02;font-style:italic;line-height:1.5;border-left:3px solid #FC4C02}
.stv .coach-feed-item .actions{display:flex;gap:8px;margin-top:10px}
.stv .coach-feed-item .actions button{padding:6px 14px;border-radius:8px;font-size:11px;font-weight:700;border:none;cursor:pointer;font-family:system-ui}
.stv .coach-feed-item .actions .primary{background:#FC4C02;color:#fff}
.stv .coach-feed-item .actions .secondary{background:transparent;border:1px solid #444;color:#888}

.snk .coach-bubble{margin:6px 16px;border-radius:24px;padding:16px 18px;position:relative}
.snk .coach-bubble.ai{background:#FFF5F8;border:2px solid #FFE0EC;border-bottom-left-radius:8px}
.snk .coach-bubble.script{background:linear-gradient(135deg,#FFF5F8,#FFF9E6);border:2px dashed #FFD600;border-bottom-right-radius:8px}
.snk .coach-bubble .header{display:flex;align-items:center;gap:8px;margin-bottom:8px}
.snk .coach-bubble .header .emoji{font-size:20px}
.snk .coach-bubble .header .label{font-size:12px;font-weight:800;color:#FF2D78}
.snk .coach-bubble .body{font-size:13px;font-weight:600;color:#555;line-height:1.5}
.snk .coach-bubble .body strong{color:#1a1a1a}
.snk .coach-bubble .script-text{font-size:13px;font-weight:700;color:#1a1a1a;line-height:1.5;font-style:italic}
.snk .coach-bubble .copy-btn{margin-top:10px;padding:8px 20px;border-radius:50px;font-size:12px;font-weight:800;border:none;cursor:pointer;font-family:'Nunito',sans-serif;background:#FF2D78;color:#fff}

</style>
</head>
<body>

<h1>Bespoke Server App — Style Explorations III</h1>
<p class="subtitle">The Grove, San Francisco — Pre-shift, momentum, and coaching views</p>

<div class="grid-wrapper">
  <div class="corner"></div>
  <div class="col-header fitbit">Fitbit</div>
  <div class="col-header strava">Strava</div>
  <div class="col-header snackpass">Snackpass</div>

  <!-- ===== ROW 1: PRE-SHIFT BRIEFING ===== -->
  <div class="row-label">Pre-Shift</div>

  <!-- FITBIT PRE-SHIFT -->
  <div class="phone">
    <div class="fit">
      <div class="sb"><span>10:52 AM</span><span>LTE &nbsp; 91%</span></div>
      <div class="page-title">Your Shift Briefing</div>
      <div class="page-sub">Lunch Shift · 11am – 3pm</div>
      <div class="briefing-header">
        <span class="emoji">🍋</span>
        <div class="title">Upsell 5 Arnold Palmers</div>
        <div class="subtitle">Estimated tip boost: +$8.40 if you hit all 5</div>
      </div>
      <div style="padding:14px 24px 4px;font-size:12px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:0.5px">Your Recent Form</div>
      <div class="stat-row">
        <div class="stat-box"><div class="sv">56%</div><div class="sl">Avg Close Rate</div></div>
        <div class="stat-box"><div class="sv">3.2</div><div class="sl">Avg Upsells/Shift</div></div>
        <div class="stat-box"><div class="sv">4</div><div class="sl">Day Streak</div></div>
      </div>
      <div style="padding:14px 24px 4px;font-size:12px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:0.5px">Today's Cashiers</div>
      <div class="matchup">
        <div class="player">
          <div class="avatar" style="background:#66D4E8">M</div>
          <div class="name">Mike R.</div>
          <div class="stat">63% close rate</div>
        </div>
        <div class="vs">vs</div>
        <div class="player you">
          <div class="avatar" style="background:#00B4D8">S</div>
          <div class="name">Sarah T. (You)</div>
          <div class="stat">56% close rate</div>
        </div>
        <div class="vs">vs</div>
        <div class="player">
          <div class="avatar" style="background:#A0E0EE">J</div>
          <div class="name">Jamie L.</div>
          <div class="stat">50% close rate</div>
        </div>
      </div>
      <div class="card">
        <div class="ct">Tip math</div>
        <div class="cs">Each Arnold Palmer adds ~$2.80 to your tips. At your current close rate, you'll likely hit 3 and earn <strong style="color:#00B4D8">+$8.40</strong>. Push for all 5 to earn <strong style="color:#00B4D8">+$14.00</strong>.</div>
      </div>
      <div class="card" style="background:#E8F8FB;border:1px solid #d0eef4">
        <div style="display:flex;align-items:center;gap:8px">
          <span style="font-size:20px">💡</span>
          <div>
            <div style="font-size:13px;font-weight:600;color:#1a1a1a">Pro tip from last week</div>
            <div style="font-size:12px;color:#999;margin-top:2px">Mentioning "fresh-squeezed" boosted your close rate by 18%</div>
          </div>
        </div>
      </div>
      <div class="nb">
        <span class="a">◉ Briefing</span>
        <span>◎ Shift</span>
        <span>◎ Board</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- STRAVA PRE-SHIFT -->
  <div class="phone">
    <div class="stv">
      <div class="sb"><span>10:52 AM</span><span>LTE &nbsp; 91%</span></div>
      <div class="hero orange">
        <div class="tag">Starting Soon</div>
        <h2>Lunch Shift<br>Arnold Palmer Sprint</h2>
        <div class="sub">11am – 3pm · Upsell 5 to complete</div>
      </div>
      <div class="warmup-card">
        <div class="header"><h3>Your Form</h3><div class="badge">4-day streak</div></div>
        <div class="stat-line"><span class="label">Avg upsells / shift</span><span class="value">3.2</span></div>
        <div class="stat-line"><span class="label">Close rate (7-day)</span><span class="value">56%</span></div>
        <div class="stat-line"><span class="label">Personal best</span><span class="value">5/5 (last Tue)</span></div>
        <div class="stat-line" style="border:none"><span class="label">Projected tip boost</span><span class="value" style="color:#FC4C02">+$8.40</span></div>
      </div>
      <div class="section-label">Today's Rivals</div>
      <div class="rival-row">
        <div class="avatar orange">M</div>
        <div class="info"><div class="name">Mike R.</div><div class="sub">63% close rate · Won last 2 shifts</div></div>
        <div class="threat high">Threat</div>
      </div>
      <div class="rival-row">
        <div class="avatar you dim">S</div>
        <div class="info"><div class="name">Sarah T. (You)</div><div class="sub">56% close rate · 4-day streak</div></div>
        <div class="pill orange">You</div>
      </div>
      <div class="rival-row">
        <div class="avatar dim">J</div>
        <div class="info"><div class="name">Jamie L.</div><div class="sub">50% close rate · New this month</div></div>
        <div class="threat low">Beatable</div>
      </div>
      <div class="btn outline" style="margin-top:12px">🏁 Ready to Start Shift</div>
      <div class="nb">
        <span class="a">◉ Prep</span>
        <span>◎ Activity</span>
        <span>◎ Club</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS PRE-SHIFT -->
  <div class="phone">
    <div class="snk">
      <div class="sb"><span>10:52 AM</span><span>LTE &nbsp; 91%</span></div>
      <div class="quest-card">
        <div class="top-row"><span class="emoji">⚔️</span><span class="xp">+85 XP</span></div>
        <h3>Today's Quest: Arnold Palmers!</h3>
        <div class="desc">Sell 5 this shift to unlock Shift MVP badge and earn +$8.40 in tip boost</div>
      </div>
      <div class="bubble-wrap">
        <div class="bubble yellow">🔥 4-day streak</div>
        <div class="bubble pink">🎯 56% close rate</div>
        <div class="bubble green">📈 3.2 avg/shift</div>
      </div>
      <div class="section-title">Your Competition 👀</div>
      <div class="opponent-card">
        <div class="avatar purple">💪</div>
        <div class="info"><div class="name">Sarah T.</div><div class="sub">You · 56% close rate</div></div>
        <div class="tag you">YOU</div>
      </div>
      <div class="opponent-card">
        <div class="avatar yellow">🔥</div>
        <div class="info"><div class="name">Mike R.</div><div class="sub">63% close rate · On a roll</div></div>
        <div class="tag rival">RIVAL</div>
      </div>
      <div class="opponent-card">
        <div class="avatar pink">✨</div>
        <div class="info"><div class="name">Jamie L.</div><div class="sub">50% close rate · Newcomer</div></div>
        <div class="tag rival">RIVAL</div>
      </div>
      <div class="gradient-card soft" style="margin-top:8px;text-align:center">
        <span class="emoji-lg" style="font-size:32px">💡</span>
        <h2 style="font-size:16px">Secret weapon from last week</h2>
        <div class="sub" style="color:#999">Saying "fresh-squeezed" boosted your close rate 18%!</div>
      </div>
      <div class="nb">
        <span class="a">◉ Quest</span>
        <span>◎ Shift</span>
        <span>◎ Board</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

  <!-- ===== ROW 2: LIVE MOMENTUM ===== -->
  <div class="row-label">Momentum</div>

  <!-- FITBIT MOMENTUM -->
  <div class="phone">
    <div class="fit">
      <div class="sb"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="page-title">Live Momentum</div>
      <div class="page-sub">1h 47m into shift · 1h 13m remaining</div>
      <div class="momentum-ring">
        <svg viewBox="0 0 160 160">
          <circle class="ring-bg-lg" cx="80" cy="80" r="65"/>
          <circle class="ring-fg-lg" cx="80" cy="80" r="65" stroke-dasharray="408.41" stroke-dashoffset="163.36"/>
          <text class="ring-text-lg" x="80" y="76">3/5</text>
          <text class="ring-sub-lg" x="80" y="95">on pace</text>
        </svg>
      </div>
      <div class="stat-row">
        <div class="stat-box"><div class="sv">+$8.40</div><div class="sl">Earned So Far</div></div>
        <div class="stat-box"><div class="sv">73min</div><div class="sl">Time Left</div></div>
      </div>
      <div class="divider" style="margin-top:8px"></div>
      <div style="padding:12px 24px 4px;font-size:12px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:0.5px">Today's Timeline</div>
      <div class="timeline">
        <div class="tl-item">
          <div class="tl-dot-col"><div class="tl-dot teal"></div><div class="tl-line teal"></div></div>
          <div class="tl-content"><div class="t1">Arnold Palmer sold <span class="tag teal" style="margin-left:6px">+$2.80</span></div><div class="t2">11:23 AM · First of the shift</div></div>
        </div>
        <div class="tl-item">
          <div class="tl-dot-col"><div class="tl-dot teal"></div><div class="tl-line teal"></div></div>
          <div class="tl-content"><div class="t1">Arnold Palmer sold <span class="tag teal" style="margin-left:6px">+$2.80</span></div><div class="t2">11:51 AM · Quick back-to-back</div></div>
        </div>
        <div class="tl-item">
          <div class="tl-dot-col"><div class="tl-dot teal"></div><div class="tl-line" style="background:transparent"></div></div>
          <div class="tl-content"><div class="t1">Arnold Palmer sold <span class="tag teal" style="margin-left:6px">+$2.80</span></div><div class="t2">12:15 PM · On a roll</div></div>
        </div>
      </div>
      <div class="card" style="background:#E8F8FB;border:1px solid #d0eef4">
        <div style="display:flex;align-items:center;gap:8px">
          <span style="font-size:18px">⚡</span>
          <div style="font-size:13px;font-weight:600;color:#0090A8">You're pacing ahead of your average. 2 more to match your personal best!</div>
        </div>
      </div>
      <div class="nb">
        <span>◎ Briefing</span>
        <span class="a">◉ Shift</span>
        <span>◎ Board</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- STRAVA MOMENTUM -->
  <div class="phone">
    <div class="stv">
      <div class="sb"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="streak-banner">
        <div class="icon">⚡</div>
        <div class="text">
          <div class="t1">3-sell streak — you're on fire</div>
          <div class="t2">Last 3 attempts all converted</div>
        </div>
      </div>
      <div class="energy-meter">
        <div class="label">Shift Energy</div>
        <div class="bars">
          <div class="bar on" style="height:45%"></div>
          <div class="bar on" style="height:55%"></div>
          <div class="bar on" style="height:65%"></div>
          <div class="bar on" style="height:78%"></div>
          <div class="bar on" style="height:90%"></div>
          <div class="bar on" style="height:95%"></div>
          <div class="bar off" style="height:40%"></div>
          <div class="bar off" style="height:35%"></div>
        </div>
        <div class="level">Peak Zone</div>
        <div class="sub">3 consecutive sells · 100% recent close rate</div>
      </div>
      <div class="stat-grid">
        <div class="stat-card"><div class="sv orange">3/5</div><div class="sl">Completed</div></div>
        <div class="stat-card"><div class="sv orange">+$8.40</div><div class="sl">Earned</div></div>
        <div class="stat-card"><div class="sv">73m</div><div class="sl">Remaining</div></div>
        <div class="stat-card"><div class="sv">56%</div><div class="sl">Close Rate</div></div>
      </div>
      <div class="section-label">Live Activity</div>
      <div class="row-item">
        <div class="ri-icon orange">🍋</div>
        <div class="ri-text"><div class="t1">Arnold Palmer sold</div><div class="t2">12:15 PM · 3rd of the shift</div></div>
        <div class="ri-right">+$2.80</div>
      </div>
      <div class="row-item">
        <div class="ri-icon orange">🍋</div>
        <div class="ri-text"><div class="t1">Arnold Palmer sold</div><div class="t2">11:51 AM · Back-to-back</div></div>
        <div class="ri-right">+$2.80</div>
      </div>
      <div class="row-item">
        <div class="ri-icon orange">🍋</div>
        <div class="ri-text"><div class="t1">Arnold Palmer sold</div><div class="t2">11:23 AM · First of shift</div></div>
        <div class="ri-right">+$2.80</div>
      </div>
      <div class="btn solid" style="margin-top:8px">2 more to match your PR — keep pushing 🔥</div>
      <div class="nb">
        <span>◎ Prep</span>
        <span class="a">◉ Activity</span>
        <span>◎ Club</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS MOMENTUM -->
  <div class="phone">
    <div class="snk">
      <div class="sb"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="gradient-card pink" style="text-align:center">
        <span class="emoji-lg">🔥</span>
        <h2>You're on a streak!</h2>
        <div class="sub">3 Arnold Palmers sold in a row</div>
      </div>
      <div class="momentum-emoji-track">
        <div class="step done">✅</div>
        <div class="step done">✅</div>
        <div class="step done">✅</div>
        <div class="step next">⭐</div>
        <div class="step pending">☆</div>
      </div>
      <div class="hype-card fire">
        <div class="big">+$8.40</div>
        <div class="label">earned so far today</div>
      </div>
      <div class="quick-stats">
        <div class="qs"><div class="v">56%</div><div class="l">Close Rate</div></div>
        <div class="qs"><div class="v">73m</div><div class="l">Time Left</div></div>
        <div class="qs"><div class="v">2nd</div><div class="l">Rank</div></div>
      </div>
      <div class="feed-item">
        <div class="emoji">🍋</div>
        <div class="text"><div class="t1">Arnold Palmer sold — 12:15 PM</div><div class="t2">+$2.80 · On a roll!</div></div>
        <div class="action pink">🎉</div>
      </div>
      <div class="feed-item">
        <div class="emoji">🍋</div>
        <div class="text"><div class="t1">Arnold Palmer sold — 11:51 AM</div><div class="t2">+$2.80 · Back to back!</div></div>
        <div class="action pink">🎉</div>
      </div>
      <div class="feed-item">
        <div class="emoji">📢</div>
        <div class="text"><div class="t1">Mike just sold his 4th!</div><div class="t2">He's 1 ahead of you — catch up!</div></div>
        <div class="action outline">💪</div>
      </div>
      <div class="nb">
        <span>◎ Quest</span>
        <span class="a">◉ Shift</span>
        <span>◎ Board</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

  <!-- ===== ROW 3: COACHING FEED ===== -->
  <div class="row-label">Coaching</div>

  <!-- FITBIT COACHING -->
  <div class="phone">
    <div class="fit">
      <div class="sb"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="page-title">Shift Coach</div>
      <div class="page-sub">AI-powered suggestions based on your shift</div>
      <div class="coach-card">
        <div class="coach-header">
          <div class="ai-badge">AI</div>
          <div class="label">Suggested Now</div>
        </div>
        <div class="coach-body">
          Your last 3 Arnold Palmer sells came after <strong>drink orders at lunch tables</strong>. The rush is peaking now — great window to keep going.
        </div>
        <div class="coach-script">"Can I start you off with an Arnold Palmer? We make ours with fresh-squeezed lemonade and it's perfect for a warm day like today."</div>
        <div class="coach-footer">
          <button class="coach-btn primary">Got it</button>
          <button class="coach-btn secondary">Show another</button>
        </div>
      </div>
      <div class="coach-card" style="border-color:#E5E5E5;background:#F8FAFB">
        <div class="coach-header">
          <div class="ai-badge" style="background:#D49B00">$</div>
          <div class="label" style="color:#D49B00">Opportunity</div>
        </div>
        <div class="coach-body">
          You're <strong>2 away from your personal best</strong>. Historically you sell more Arnold Palmers in the 12:30–1:30 window. That window is now.
        </div>
      </div>
      <div class="coach-card" style="border-color:#E5E5E5;background:#F8FAFB">
        <div class="coach-header">
          <div class="ai-badge" style="background:#22C55E">✓</div>
          <div class="label" style="color:#22C55E">What's Working</div>
        </div>
        <div class="coach-body">
          Mentioning <strong>"fresh-squeezed"</strong> has been your highest-converting phrase this week (73% close rate vs. 56% overall). Keep using it.
        </div>
      </div>
      <div class="card" style="text-align:center">
        <div class="ct">Your coaching stats</div>
        <div style="display:flex;justify-content:space-around;margin-top:8px">
          <div><div style="font-size:18px;font-weight:700;color:#00B4D8">12</div><div style="font-size:10px;color:#999">Tips used</div></div>
          <div><div style="font-size:18px;font-weight:700;color:#00B4D8">+18%</div><div style="font-size:10px;color:#999">Close rate lift</div></div>
          <div><div style="font-size:18px;font-weight:700;color:#00B4D8">73%</div><div style="font-size:10px;color:#999">Best phrase</div></div>
        </div>
      </div>
      <div class="nb">
        <span>◎ Briefing</span>
        <span>◎ Shift</span>
        <span class="a">◉ Coach</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- STRAVA COACHING -->
  <div class="phone">
    <div class="stv">
      <div class="sb"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div style="padding:16px 20px 0">
        <div style="font-size:18px;font-weight:800">Live Coach</div>
        <div style="font-size:12px;color:#666;margin-top:4px">Real-time suggestions from your AI coach</div>
      </div>
      <div class="coach-feed-item" style="margin-top:12px;border-color:#FC4C02">
        <div class="top">
          <div class="ai">AI</div>
          <div class="label">Try This Now</div>
          <div class="time">Just now</div>
        </div>
        <div class="body">You're in the <strong>peak lunch window</strong>. Your best Arnold Palmer conversions happen in the next 45 minutes. Stay aggressive.</div>
        <div class="script">"Can I start you off with our Arnold Palmer? It's fresh-squeezed and perfect for today."</div>
        <div class="actions">
          <button class="primary">Use this script</button>
          <button class="secondary">Dismiss</button>
        </div>
      </div>
      <div class="coach-feed-item">
        <div class="top">
          <div class="ai" style="background:#22C55E">✓</div>
          <div class="label" style="color:#22C55E">Winning Pattern</div>
          <div class="time">12:15 PM</div>
        </div>
        <div class="body"><strong>"Fresh-squeezed"</strong> is your secret weapon. It converts at <strong>73%</strong> vs. your 56% average. You've used it for all 3 sells today.</div>
      </div>
      <div class="coach-feed-item">
        <div class="top">
          <div class="ai" style="background:#F59E0B">⚡</div>
          <div class="label" style="color:#F59E0B">Competitor Intel</div>
          <div class="time">12:10 PM</div>
        </div>
        <div class="body">Mike just sold his 4th Arnold Palmer. He's <strong>1 ahead of you</strong>. You've got the streak momentum — this is your chance to pull even.</div>
      </div>
      <div class="coach-feed-item">
        <div class="top">
          <div class="ai" style="background:#8B5CF6">📊</div>
          <div class="label" style="color:#8B5CF6">Insight</div>
          <div class="time">11:55 AM</div>
        </div>
        <div class="body">You're <strong>2 away from your personal best</strong> (5/5, last Tuesday). Your pacing is ahead of that shift at this point in the day.</div>
      </div>
      <div class="nb">
        <span>◎ Prep</span>
        <span>◎ Activity</span>
        <span class="a">◉ Coach</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS COACHING -->
  <div class="phone">
    <div class="snk">
      <div class="sb"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="gradient-card yellow" style="padding:16px 20px;text-align:center">
        <span style="font-size:32px;display:block;margin-bottom:4px">🤖✨</span>
        <h2 style="font-size:18px">Your AI Coach</h2>
        <div class="sub" style="color:#7a6800">Tips and scripts to boost your sales</div>
      </div>
      <div class="coach-bubble ai">
        <div class="header"><span class="emoji">🎯</span><span class="label">Try This Now!</span></div>
        <div class="body">The lunch rush is peaking! This is your <strong>best window</strong> for Arnold Palmer upsells. You've sold 3 — go for the personal best!</div>
      </div>
      <div class="coach-bubble script">
        <div class="header"><span class="emoji">💬</span><span class="label">Suggested Script</span></div>
        <div class="script-text">"Can I start you off with an Arnold Palmer? We make ours with fresh-squeezed lemonade — it's the perfect lunch drink!"</div>
        <button class="copy-btn">📋 Copy Script</button>
      </div>
      <div class="coach-bubble ai">
        <div class="header"><span class="emoji">🔥</span><span class="label">Hot Tip!</span></div>
        <div class="body">Saying <strong>"fresh-squeezed"</strong> has been your magic word this week — <strong>73% close rate</strong> when you use it vs. 56% without!</div>
      </div>
      <div class="coach-bubble ai">
        <div class="header"><span class="emoji">👀</span><span class="label">Rival Alert!</span></div>
        <div class="body">Mike just sold his 4th! He's <strong>1 ahead</strong>. But you've got the streak — 3 in a row! Can you catch him?</div>
      </div>
      <div class="feed-item" style="margin-top:4px">
        <div class="emoji">📊</div>
        <div class="text"><div class="t1">12 coaching tips used this week</div><div class="t2">Your close rate is up 18% since you started</div></div>
      </div>
      <div class="nb">
        <span>◎ Quest</span>
        <span>◎ Shift</span>
        <span class="a">◉ Coach</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>
</div>

<p class="footer">Concept mockups for design partner discussion — March 2026</p>

</body>
</html>`;

export default bespokeServerAppMockups3Html;
